var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAutoSend = function SvgAutoSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 36,
    x: 6,
    y: 13,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 9,
    x: 6,
    y: 13,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1,
    x: 12.5,
    y: 31,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1,
    x: 15.5,
    y: 34.5,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    rx: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 18.5,
    y: 38,
    fill: "var(--c-blue)",
    stroke: "var(--c-blue2)",
    rx: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 14,
    x: 24,
    y: 28.5,
    fill: "#fff",
    stroke: "var(--c-main-menu-num)",
    strokeWidth: 2,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-main-menu-num)",
    strokeWidth: 2,
    d: "m24 31.5 10.08 5.28c.27.14.58.14.85.02L46 31.5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 11,
    y: 16.5,
    fill: "var(--c-blue)",
    stroke: "var(--c-blue2)",
    rx: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 15.5,
    y: 16.5,
    fill: "var(--c-blue)",
    stroke: "var(--c-blue2)",
    rx: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 20,
    y: 16.5,
    fill: "var(--c-blue)",
    stroke: "var(--c-blue2)",
    rx: 0.5
  })));
};
export default SvgAutoSend;